import { useState } from "react";
import { Cell, ColumnDef, flexRender, Row } from "@tanstack/react-table";

import styles from "./MobileCard.module.scss";

export interface MobileCardProps {
    columns: ColumnDef<any, any>[];
    row: Row<any>;
    headerColIndex?: number;
    secHeaderColIndex?: number;
}

export const MobileCard = ({ columns, row, headerColIndex, secHeaderColIndex }: MobileCardProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={styles.wrapper}>
            <div className={styles.header}>
                <div>
                    <div className={styles.header_title}>{columns?.[headerColIndex || 0]?.header as string}</div>
                    <div className={styles.header_value}>
                        {flexRender(
                            row.getVisibleCells()?.[headerColIndex || 0]?.column?.columnDef?.cell,
                            row.getVisibleCells()?.[headerColIndex || 0]?.getContext?.()
                        )}
                    </div>
                </div>
                <div>
                    <div className={styles.header_title}>{columns?.[secHeaderColIndex || 1]?.header as string}</div>
                    <div className={styles.header_value}>
                        {flexRender(
                            row.getVisibleCells()?.[secHeaderColIndex || 1]?.column?.columnDef?.cell,
                            row.getVisibleCells()?.[secHeaderColIndex || 1]?.getContext?.()
                        )}
                    </div>
                </div>
                <div className={styles.open_button}>
                    <button className={styles.header_button} onClick={() => setIsOpen(!isOpen)}>
                        {isOpen ? "▲" : "▼"}
                    </button>
                </div>
            </div>
            {!isOpen ? null : (
                <div className={styles.grid}>
                    {columns.map((column, index) => {
                        if (index === headerColIndex || index === secHeaderColIndex) {
                            return null;
                        }

                        return (
                            <GridElement
                                key={column.id}
                                header={column.header as string}
                                cell={row.getVisibleCells()?.[index]}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

const GridElement = ({ header, cell }: { header: string; cell: Cell<any, any> }) => {
    return (
        <div className={styles.grid_element}>
            <div className={styles.grid_element_header}>{header}</div>
            <div className={styles.grid_element_value}>
                {flexRender(cell?.column?.columnDef?.cell, cell.getContext())}
            </div>
        </div>
    );
};
